import R from 'ramda';
import getFilteredProducts from './get-filtered-products';
import getSubcategories from './get-subcategories';

export const getUniqueOptions = ({ products = [], categoryName }) => (
  R.compose(
    R.reduce((uniqueOptions, option) => {
      const exists = !!uniqueOptions.find(({ name }) => name === option.name);
      return exists ? uniqueOptions : [...uniqueOptions, option];
    }, []),
    R.flatten,
    R.map(({ filterCategories }) => (
      getSubcategories({ categoryName, categories: filterCategories })
    )),
  )(products)
);

// The number shown next to each option is what the revised number of
// products will be if that option is toggled so we append the object
// to selectedFilters if the option is not selected and remove it from
// selectedFilters if it is selected
export const getProspectiveFilters = ({
  selectedFilters = [],
  categoryName,
  optionName,
  isSelected,
}) => (
  isSelected ? (
    selectedFilters.filter(selectedFilter => (
      selectedFilter.categoryName !== categoryName && selectedFilter.optionName !== optionName
    ))
  ) : (
    [...selectedFilters, { categoryName, optionName }]
  )
);

export const getFilteredProductCount = ({
  products,
  selectedFilters,
  categories,
  categoryName,
  optionName,
  isSelected,
}) => {
  const prospectiveFilters = getProspectiveFilters({
    selectedFilters,
    categoryName,
    optionName,
    isSelected,
  });

  const filteredProducts = getFilteredProducts({
    products,
    selectedFilters: prospectiveFilters,
    categories,
  });

  return filteredProducts.length;
};

export const mapCategoryOption = ({
  option = {},
  categoryName,
  selectedFilters = [],
  products = [],
  categories = [],
}) => {
  const isSelected = !!selectedFilters.find(filter => (
    filter.optionName === option.name && filter.categoryName === categoryName
  ));

  const count = getFilteredProductCount({
    products,
    selectedFilters,
    categories,
    categoryName,
    optionName: option.name,
    isSelected,
  });

  return {
    ...option,
    isSelected,
    count,
  };
};

export default ({ products = [], categoryNames = [], selectedFilters = [] }) => (
  categoryNames
    .map(categoryName => ({
      name: categoryName,
      options: getUniqueOptions({ products, categoryName }),
    }))
    .map((category, index, categories) => ({
      ...category,
      options: category.options.map(option => mapCategoryOption({
        option,
        categoryName: category.name,
        selectedFilters,
        products,
        categories,
      })),
    }))
);
